var _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCancelWebBookingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 4,
    fill: "#ECEDF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.1829 35.6967L41.0009 38.8787L37.8189 35.6967L35.6976 37.818L38.8796 41L35.6976 44.182L37.8189 46.3033L41.0009 43.1213L44.1829 46.3033L46.3042 44.182L43.1222 41L46.3042 37.818L44.1829 35.6967Z",
    fill: "#96A0BC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41 53C34.4 53 29 47.6 29 41C29 34.4 34.4 29 41 29C47.6 29 53 34.4 53 41C53 47.6 47.6 53 41 53ZM41 32C36.05 32 32 36.05 32 41C32 45.95 36.05 50 41 50C45.95 50 50 45.95 50 41C50 36.05 45.95 32 41 32Z",
    fill: "#96A0BC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 17C50 15.35 48.65 14 47 14H41V11H38V14H26V11H23V14H17C15.35 14 14 15.35 14 17V47C14 48.65 15.35 50 17 50H26V47H17V17H23V20H26V17H38V20H41V17H47V26H50V17Z",
    fill: "#96A0BC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelWebBookingIcon);
export default __webpack_public_path__ + "static/media/cancelWebBookingIcon.3b814ef0eaec6e4fdf74c7d0684c582e.svg";
export { ForwardRef as ReactComponent };